import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateTaxRate } from "../../api/apiTax";
import parseError from "../../utils/parseError";

export const useUpdateTaxRate = () => {
    const queryClient = useQueryClient();

    const { mutate: updateTaxRateMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateTaxRate(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Tax rate updated successfully");
            queryClient.invalidateQueries(["tax-rates"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update tax rate");
        },
    });

    return { updateTaxRateMutate, isUpdating };
};
